const content: { [key: string]: string } = {
  keyMetrics: "Key Metrics",
  personalPV: "Personal PV",
  ppv: "PPV",
  personalBV: "Personal BV",
  rubyPV: "Ruby PV",
  rubyBV: "Ruby BV",
  groupOrdersCount: "Total Orders",
  qLegs: "Q Legs",
  qualifiedLegs: "Qualified Legs",
  vcsPV: "VCS PV",
  nonVCSPV: "Non VCS PV",
  personalVcsPercent: "VCS %",
  totalCustomerCount: "Total Customers",
  customers: "Customers",
  groupPV: "GPV",
  groupPVNeeded: "GPV Needed",
  totalABOCount: "Group Size",
  leadershipPercent: "Leadership %",
  leadershipPV: "Leadership PV",
  totalNewABOCount: "New ABOs",
  newCustomerCount: "New Customers",
  totalCustomerOrder: "Customer Orders",
  customerOrdersCount: "Customer Orders",
  keyMetricsMenuArialLabel: "Configure Key Metrics",
  kpiSelectorTitle: "Selectable KPIs ({totalSelected}/{maxSelection})",
  kpiSelectorTitleMobile: "Selectable KPIs",
  kpiSelectorCloseArialLabel: "Close",
  kpiSelectorBackdropAriaLabel: "Close key metrics selector",
  kpiSelectorModalApply: "Apply",
  kpiSelectorModalCancel: "Cancel",
  superLegs: "Super Legs",
  superLegsModalTitle: "Super Leg Bonus",
  superLegsModalDescription:
    "Super Leg bonus amounts of 20,000/40,000 USD per leg will be presented in the currency of the FAA participant's primary business. Super Leg bonus amounts will use the exchange rate from the monthly bonus calculation for the last month processed. The final bonus calculation for these payments will be based upon the August exchange rate of the performance year in which the payment was earned. Super Leg payments will be paid with the annual FAA payment.",
  spMonths: "SP Months",
  spMonthsLabelSingular: "{value} Month",
  spMonthsLabelPlural: "{value} Months",
  annualGroupPV: "Annual GPV",
  annualRubyPV: "Annual RPV",
  annualVePV: "Annual VE PV",
  annualPersonalPV: "Annual PPV",
  annualVcsPercent: "Annual VCS %",
  annualNewCustomerCount: "New Customers",
  businessEffectiveDate: "Business Effective Date",
  vcsSales: "Verified Customer Sales",
  annualNewABOCount: "New ABOs",
  annualCustomerOrders: "Customer Orders",
  sponsoring: "Sponsoring",
  sponsoringYtd: "Annual Sponsoring",
  sponsoringYtdStar: "Annual Sponsoring",
  ppvYtd: "PPV Sum*",
  autoRenewal: "Auto Renewal",
  bonus: "Bonus %",
  bonusPercent: "Bonus %",
  customerPv: "Customer PV",
  customerPV: "Customer PV",
  sponsorName: "Sponsor Name",
  description: "*To view Annual* KPIs, select the 'Last 3 Months' or 'Last 4 Months' tabs.",
  pointsToNextLevel: "Points to Next Level",
  nonVcs: "Non VCS PV",
  renewalDate: "Renewal Date",
  gbv: "GBV",
  frontlines: "Frontlines",
  registration: "Registration Date",
  keyMetricsToastMessage:
    "You’ve reached the maximum amount of key metrics. To add another, please unselect one of your current selections.",
  totalPpv: "Total PPV",
  ppvTarget: "PPV Target",
  percentagePpv: "Percentage of PPV",
  cpvPercent: "Customer PV %",
  customizeKpis: "Customize Your KPIs",
  nonBonusable: "Non-bonusable BV",
  nonBonusableBV: "Non-bonusable BV",
  annualPPV: "Annual PPV",
  vePV: "Total Organization PV",
  vePVSubtext: "(Formally called VE PV)",
  vePVModalTitle: "Total Organization PV",
  vePVModalDescription:
    "This volume represents your Personal Volume plus TOTAL downline in market volume with no restrictions. It represents your total organizational in market PV for the month all the way to the bottom of each leg.",
  personalPVRequirement: "PPV Target",
  vcspvTarget: "VCS PV Target",
  papvTarget: "PAPV Target",
  pcpvTarget: "PCPV Target",
  personalOrders: "Personal Orders",
  newPersonalCustomers: "New Personal Customers",
  personalCustomerOrders: "Personal Customer Orders",
  totalPersonalCustomers: "Total Personal Customers",
  performanceBonus: "Performance Bonus",
  groupSize: "Group Size",
  groupOrders: "Group Orders",
  groupBV: "Group BV",
  totalOrgPV: "Total Organization PV",
  personalOrdersCount: "Personal Orders",
  pyYear: "PY",
  returnPV: "Return PV",
  isFirstContractYear: "First Contract Year",
  veVolumePV: "Total Organization PV",
};

export default content;
